import { locales } from 'nuxt-base/composables/useLocale._my_'
import type { RouteLocationRaw, RouteRecordNameGeneric, RouteLocationResolvedGeneric } from '#vue-router'

export const addBase = '__i18n___'
export const middilwareName = 'i18n-my'

function updateRouteNameStart(lang: Locales) {
  return addBase + lang + '__'
}
export function updateRouteName(lang: Locales, name: string | None | RouteRecordNameGeneric): string | undefined {
  return name ? updateRouteNameStart(lang) + name?.toString() : undefined
}
export function isLt(lang: string | None): boolean {
  return lang === 'lt' || lang === 'ltu'
}
export function isEn(lang: string | None): boolean {
  return lang === 'en' || lang === 'eng'
}

export function toLang(lang: string | None): Locales | undefined {
  return isLt(lang) ? locales.lt : isEn(lang) ? locales.en : undefined
}
export function checkRouteLocale(lang: Locales, path: string): boolean {
  return path === `/${lang}` || path.startsWith(`/${lang}/`)
}

const _cacheMyLinkNameStarts: string[] = []
export function myLinkName(route: Pick<RouteLocationResolvedGeneric, 'name'> | undefined): string | undefined {
  if (!(typeof route === 'object' && 'name' in route)) return
  // Init start obj and cache them
  if (!_cacheMyLinkNameStarts.length) {
    for (const lang1 in locales) {
      const lang = toLang(lang1)
      const lang3 = lang ? updateRouteNameStart(lang) : undefined
      if (lang3) _cacheMyLinkNameStarts.push(lang3)
    }
  }

  const name = route.name?.toString()
  if (name) {
    for (const start of _cacheMyLinkNameStarts) {
      if (name?.startsWith(start)) return name.slice(start.length)
    }
  }
  return name
}

const trackingQueryKeys: ReadonlySet<string> = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',

  'gclid',
  'dclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',

  'device',
  'network',
  'matchtype',
  'targetid',
  'creative',
  'loc_interest_ms',
  'loc_physical_ms',

  'fbclid',
  'msclkid',
  'srsltid',

  '_gl',
])

function fixQuery(queryOrg: RouteLocationResolvedGeneric['query']): RouteLocationResolvedGeneric['query'] {
  let query = queryOrg
  for (const key in queryOrg) {
    if (!trackingQueryKeys.has(key)) continue
    if (query === queryOrg) query = { ...queryOrg }
    delete query[key]
  }
  return query
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useI18nRouteRewrite() {
  const router = useRouter()
  return {
    router,
    rewrite(route: RouteLocationRaw, locale: Locales | undefined): RouteLocationResolvedGeneric {
      const org = router.resolve(route)
      const hasMiddilware = org.meta.middleware === middilwareName || (Array.isArray(org.meta.middleware) && org.meta.middleware.includes(middilwareName))
      const nameOrg = org.name?.toString()
      if (!hasMiddilware && !nameOrg?.startsWith(addBase)) return org
      const nameBase = myLinkName(org)
      const name = locale ? updateRouteName(locale, nameBase) : nameBase
      const query = fixQuery(org.query)
      return name === nameOrg && query === org.query ? org : router.resolve({ params: org.params, query, name, hash: org.hash })
    },
  }
}
